module.exports = __webpack_public_path__ + "static/media/6845.90b19e48.jpg";